import { render, staticRenderFns } from "./FilooTerm.vue?vue&type=template&id=0882a9a4"
import script from "./FilooTerm.vue?vue&type=script&lang=js"
export * from "./FilooTerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports